function getDateDifference(start_date: string, end_date: string): number {
  const start: number = new Date(start_date).getTime();
  const end: number = new Date(end_date).getTime();
  const difference = Math.abs(end - start) / 3600000;

  return difference;
}

export default getDateDifference;
